import { useQuery } from "@tanstack/react-query";
import { request } from "hooks/useOkoApi/useOkoApi";
import { useAuthReady } from "hooks/useAuthReady";

/**
 * The session's transcript, for the console's Teacher View.
 *
 * The transcript is NOT part of the model output. It comes from its own fetch
 * and has no dependency on the report JSON at all, which is exactly why it is
 * the one tab whose behaviour cannot vary by prompt version.
 *
 * Fetched once with the run, not on the switch into Teacher View: toggling
 * views must issue no new request at all (D16), and the tab must be ready when
 * the admin opens it. Cached forever, so it is fetched once per session.
 *
 * @param {string|null} sessionId The session the run was made against, or null
 *   to skip the request entirely.
 * @returns {{transcript: object|null, isLoading: boolean}}
 */
export const useConsoleTranscript = (sessionId) => {
  const authReady = useAuthReady();

  const { data, isLoading } = useQuery({
    queryKey: ["console-transcript", sessionId],
    queryFn: () => request(`session_summary/${sessionId}/transcript`, { method: "GET" }),
    enabled: Boolean(sessionId) && authReady,
    staleTime: Infinity,
    cacheTime: Infinity
  });

  return { transcript: data ?? null, isLoading: Boolean(sessionId) && isLoading };
};
